module.exports = __webpack_public_path__ + "img/medio7.ba741a9b.jpg";